import {
  oldToNewBrowsePathsMap,
  superBrowseToBrowseMap,
  TMOBILE_PLACEHOLDER_URLS,
} from '../../constants/Urls';

import { getNotFoundPath } from './shared';

export function isNewBrowseCategoryPath(pathname: string): boolean {
  return /^\/browse\/music\/genres\/[\w]+$/.test(pathname);
}

export function isNewBrowseActivitiesPath(pathname: string): boolean {
  return /^\/browse\/music\/activities\/[\w]+$/.test(pathname);
}

export function isNewBrowseDecadesPath(pathname: string): boolean {
  return /^\/browse\/music\/decades\/[\w]+$/.test(pathname);
}

export function isNewBrowsePodcastsPath(pathname: string): boolean {
  return /^\/browse\/podcasts\/[\w]+$/.test(pathname);
}

export function getBrowsePath() {
  return '/browse' as const;
}

export function isBrowsePath(path: string): boolean {
  const browse = getBrowsePath();
  return path === browse || !!(path && path.indexOf(browse + '/') === 0);
}

export function getBrowseGenreCategoryPath(categoryName: string) {
  return `/music/${categoryName}` as const;
}

export function getNewBrowseDecadesPath() {
  return '/browse/music/decades' as const;
}

export function mapOldBrowseToNewBrowse(pathname: string): string {
  if (pathname in oldToNewBrowsePathsMap) {
    return oldToNewBrowsePathsMap[pathname as keyof typeof oldToNewBrowsePathsMap];
  }

  return getNotFoundPath();
}

export function mapSuperBrowseToBrowse(pathname: string): string {
  if (pathname in superBrowseToBrowseMap) {
    return superBrowseToBrowseMap[pathname as keyof typeof superBrowseToBrowseMap];
  }

  return getNotFoundPath();
}

export function isOldBrowseCategoryPath(pathname: string): boolean {
  return /^\/music\/genres\/.+$/.test(pathname);
}

export function isOldBrowseDecadesPath(pathname: string): boolean {
  return /^\/music\/decades\/.+$/.test(pathname);
}

export function isOldBrowsePath(pathname: string): boolean {
  return /^\/music\/.+$/.test(pathname);
}

export function isSuperBrowsePath(pathname: string): boolean {
  return pathname.startsWith('/browse/content');
}

export function getBrowsePodcastsPath() {
  return '/browse/podcasts' as const;
}

export function isPodcastPath(pathname: string): boolean {
  return pathname.startsWith('/podcast');
}

export function getBrowseEpisodesPath() {
  return '/browse/podcasts/episodes' as const;
}

export function isTmobileBrowsePath(pathname: string): boolean {
  return TMOBILE_PLACEHOLDER_URLS[pathname as keyof typeof TMOBILE_PLACEHOLDER_URLS] === true;
}
